module.exports = __webpack_public_path__ + "img/tuijianchapin.f0435382.png";